module.exports = __webpack_public_path__ + "img/live_example.b783bea8.png";